import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import s from './Address.style';

class Address extends Component {
  render() {
    return (
      <div className={css(s.addressSection)}>
        <h2 className={css(s.addressTitle)}>Stúdió Helyszín</h2>
        <div className={css(s.addressInner)}>
          <p className={css(s.addressText)}>
            <b>The Makeup Lab</b>
            <br />
            1054 Budapest, Hold utca 21.
            <br />
            V. kerület (5. kerület), Belváros
            <br />
            <br />
            <b>Telefon:</b> <a href="tel:+36202945757">+36 20 294 5757</a>
            <br />
            <b>Email:</b> <a href="mailto:hello@themakeuplab.hu">hello@themakeuplab.hu</a>
            <br />
            <b>Nyitvatartás:</b> Hétfő – Szombat, 9:00 – 18:00
            <br />
            <b>Megközelítés:</b> M2, M3 metró, 70-es, 78-as troli, 2, 2B, 23-as villamos.
            <br />
            Autóval fizetős parkolás (kód: 0501).
          </p>
        </div>
      </div>
    );
  }
}

export default Address;
